module.exports = __webpack_public_path__ + "static/media/Statuts.9671b9b9.pdf";